
        Component.define('slider-ingredients', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $slider = $el.find('.slider-ingredients');

$slider.on('init', function(event, slick){
    setTimeout(function(){
        $document.trigger('slider-ingredients:read');
    },1000);
});

$slider.slick({
    slidesToShow: params.items[0],
    slidesToScroll: 1,

    responsive: [
        {
            breakpoint: params.items[1][0],
            settings: {
                slidesToShow: params.items[1][1]
            }
        },
    ]
});



        });